import ApplicationForm from "../components/ApplicationForm";
export default function AdmissionPage() { return <ApplicationForm formType="admission" />; }
